export default "__VITE_ASSET__BG6j44ku__"